const setFormData = (state, { type, data }) => {
  state.formData[type] = data;
};

const setUserIdentity = (state, payload) => {
  if (payload.type === "update") {
    state.userIdentity[payload.fieldName] = payload.fieldValue;
    return;
  }
  state.userIdentity = payload;
};

const setUserLocationIdentity = (state, payload) => {
  state.userLocationIdentity = payload;
};

export default {
  setFormData,
  setUserIdentity,
  setUserLocationIdentity,
};
